import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { MdOutlinePlayArrow, MdRestartAlt, MdVideoCameraBack } from "react-icons/md";
import { useParams } from "react-router-dom";

import { ReactComponent as ImageLibraryIcon } from "../../../../assets/imageLibrary.svg";
import { ReactComponent as SoundLibraryIcon } from "../../../../assets/soundLibrary.svg";
import useAuth from "../../../../hooks/useAuth";
import Button from "../../../Button";
import ImageLibrary from "../../../modals/common/ImageLibrary";
import SoundLibrary from "../../../modals/common/SoundLibrary";
import WatchVideoModal from "../../../modals/common/WatchVideoModal";
import ImageLibraryStudent from "../../../modals/student/ImageLibrary";
import SoundLibraryStudent from "../../../modals/student/SoundLibrary";

const SmoothyHeader = ({
  isTeacher,
  onRunCode,
  isLoading,
  showNextHint,
  resetSnippet,
  snippet,
  setIsHorizontal,
  isHorizontal,
  resetSmoothyCodeAndRunCode = () => {},
  hasCodeContent = () => {},
}) => {
  const { type = "playground", lessonID } = useParams();
  const { t } = useTranslation();
  const soundLibraryModalRef = useRef();
  const imageLibraryModalRef = useRef();
  const soundLibraryStudentModalRef = useRef();
  const imageLibraryStudentModalRef = useRef();
  const watchVideoModalRef = useRef();

  const user = useAuth();

  const openSoundLibraryModal = () => soundLibraryModalRef.current.openModal();
  const openImageLibraryModal = () => imageLibraryModalRef.current.openModal();
  const openSoundLibraryStudentModal = () => soundLibraryStudentModalRef.current.openModal();
  const openImageLibraryStudentModal = () => imageLibraryStudentModalRef.current.openModal();
  const openWatchVideoModal = (lessonID, videoType) =>
    watchVideoModalRef.current?.openModal(lessonID, videoType);

  const handleSoundLibrarySuccess = () => {};
  const handleImageLibrarySuccess = () => {};

  return (
    <div className="relative mb-4 flex justify-between">
      {user.role == "student" ? (
        <>
          {type == "code" ? (
            <div className="flex items-center gap-2">
              {snippet && (
                <Button
                  iconLeft={<MdRestartAlt size={20} />}
                  onClick={resetSnippet}
                  label={t("reset_code")}
                  className="min-w-28"
                />
              )}
              <Button
                iconLeft={<MdVideoCameraBack size={20} />}
                onClick={() => openWatchVideoModal(lessonID, "lesson")}
                label={t("show_lesson_video")}
                className="min-w-28"
              />
            </div>
          ) : (
            <div className="min-w-28"></div>
          )}
          <Button
            iconLeft={<MdOutlinePlayArrow size={24} />}
            loading={isLoading}
            onClick={() => onRunCode()}
            disabled={isLoading}
            label={t("run")}
            className="absolute left-3 top-[67vh] z-50 min-w-28"
          />
        </>
      ) : (
        <Button
          iconLeft={<MdOutlinePlayArrow size={20} />}
          loading={isLoading}
          onClick={() => onRunCode()}
          disabled={isLoading}
          label={t("run")}
          className="min-w-28"
        />
      )}
      <div className="flex gap-2">
        {!isTeacher && !snippet && (
          <Button
            iconLeft={<MdRestartAlt size={20} />}
            onClick={resetSmoothyCodeAndRunCode}
            label={t("reset_code")}
            className="min-w-28"
            disabled={!hasCodeContent()}
          />
        )}
        <Button
          iconLeft={<SoundLibraryIcon />}
          label={t("sound_library")}
          onClick={() => (user.role == "student" ? openSoundLibraryStudentModal() : openSoundLibraryModal())}
        />
        <Button
          iconLeft={<ImageLibraryIcon />}
          label={t("image_library")}
          onClick={() => (user.role == "student" ? openImageLibraryStudentModal() : openImageLibraryModal())}
        />
        {/* <Button
          icon={
            <MdFlip
              size={22}
              style={{
                transform: isHorizontal ? "rotate(0deg) " : "rotate(90deg)",
                transition: "transform 0.3s ease", // Smooth transition for rotation
              }}
            />
          }
          onClick={() => setIsHorizontal(!isHorizontal)}
        /> */}
      </div>
      <SoundLibrary ref={soundLibraryModalRef} onSubmit={handleSoundLibrarySuccess} />
      <ImageLibrary ref={imageLibraryModalRef} onSubmit={handleImageLibrarySuccess} />
      <SoundLibraryStudent ref={soundLibraryStudentModalRef} onSubmit={handleSoundLibrarySuccess} />
      <ImageLibraryStudent ref={imageLibraryStudentModalRef} onSubmit={handleImageLibrarySuccess} />
      <WatchVideoModal ref={watchVideoModalRef} />
    </div>
  );
};

export default SmoothyHeader;
